import Vue from "vue";
import VueRouter from "vue-router";

import Login from "@/view/Login.vue";
import SideBar from "@/components/Common/SideBar.vue";
import Dashboard from "@/view/Dashboard.vue";
import Orders from "@/view/Orders.vue";
import Accounts from "@/view/Accounts.vue";
import ForgotAccounts from "@/view/ForgotAccounts.vue";
import FindId from "@/view/FindId.vue";
import FindPw from "@/view/FindPw.vue";
import PrivacyPolicy from "@/view/PrivacyPolicy.vue";
import common from "@/util/common.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    components: {
      content: Login,
    },
    beforeEnter: common.requireToken("login"),
  },
  {
    path: "/Login",
    name: "Login",
    components: {
      content: Login,
    },
    beforeEnter: common.requireToken("login"),
  },
  {
    path: "/ForgotAccounts",
    name: "ForgotAccounts",
    components: {
      content: ForgotAccounts,
    },
    beforeEnter: common.requireToken("forgot"),
  },
  {
    path: "/FindId",
    name: "FindId",
    components: {
      content: FindId,
    },
    beforeEnter: common.requireToken("findId"),
  },
  {
    path: "/FindPw",
    name: "FindPw",
    components: {
      content: FindPw,
    },
    beforeEnter: common.requireToken("findPw"),
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    components: {
      header: SideBar,
      content: Dashboard,
    },
    beforeEnter: common.requireToken("master"),
  },
  {
    path: "/Orders",
    name: "Orders",
    components: {
      header: SideBar,
      content: Orders,
    },
    beforeEnter: common.requireToken("admin"),
  },
  {
    path: "/Accounts",
    name: "Accounts",
    components: {
      header: SideBar,
      content: Accounts,
    },
    beforeEnter: common.requireToken("admin"),
  },
  {
    path: "/PrivacyPolicy",
    name: "PrivacyPolicy",
    components: {
      content: PrivacyPolicy,
    },
  },
  {
    path: "*",
    redirect: "Orders",
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export const router = new VueRouter({
  routes,
});
